import React, { useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material-ui
import { makeStyles } from '@material-ui/styles';
import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput } from '@material-ui/core';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';
import useAuth from 'hooks/useAuth';
import useScriptRef from 'hooks/useScriptRef';
import axiosServices from 'utils/axios';
import SimpleReactValidator from 'simple-react-validator';
import { useImmer } from 'use-immer';

// style constant
const useStyles = makeStyles((theme) => ({
    loginInput: {
        ...theme.typography.customInput
    }
}));

// ========================|| FIREBASE - FORGOT PASSWORD ||======================== //

const FirebaseForgotPassword = ({ ...others }) => {
    const navigate = useNavigate();
    const classes = useStyles();
    const [, forceUpdate] = useState();
    const validator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate }
        })
    );
    const [state, setState] = useImmer({ isBusy: false, error: '', email: '' });

    const handleChange = (e) => {
        setState((draft) => {
            draft.email = e.target.value;
            draft.error = '';
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validator.current.allValid()) {
            setState((draft) => {
                draft.isBusy = true;
            });
            const formData = new FormData();
            formData.append('email', state.email);
            axiosServices
                .post('/v2/pixujob/forgot_password', formData)
                .then((res) => {
                    if (res.data.status_code === 200) {
                        navigate('/pages/confirm-mail/confirm-mail', { replace: true, state: { email: state.email, from: 'forgot' } });
                    } else {
                        setState((draft) => {
                            draft.error = res.data.message;
                        });
                    }
                    setState((draft) => {
                        draft.isBusy = false;
                    });
                })
                .catch((err) => {
                    console.log(err);
                    setState((draft) => {
                        draft.isBusy = false;
                    });
                });
        } else {
            validator.current.showMessages();
            forceUpdate(1);
        }
    };

    const { firebaseEmailPasswordSignIn } = useAuth();

    return (
        <form noValidate onSubmit={handleSubmit} {...others}>
            <FormControl fullWidth className={classes.loginInput}>
                <InputLabel htmlFor="outlined-adornment-email-forgot">Email ID</InputLabel>
                <OutlinedInput
                    id="outlined-adornment-email-forgot"
                    type="email"
                    value={state.email}
                    name="email"
                    onChange={handleChange}
                    label="Email ID"
                    inputProps={{
                        classes: {
                            notchedOutline: classes.notchedOutline
                        }
                    }}
                />
                {validator.current.message('Email', state.email, 'required|email') && (
                    <FormHelperText error id="standard-weight-helper-text-email-forgot">
                        {validator.current.message('Email', state.email, 'required|email')}
                    </FormHelperText>
                )}
            </FormControl>

            {state.error !== '' && (
                <Box
                    sx={{
                        mt: 3
                    }}
                >
                    <FormHelperText error>{state.error}</FormHelperText>
                </Box>
            )}

            <Box
                sx={{
                    mt: 2
                }}
            >
                <AnimateButton>
                    <Button
                        disableElevation
                        disabled={state.isBusy}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        color="secondary"
                    >
                        Reset Password
                    </Button>
                </AnimateButton>
            </Box>
        </form>
    );
};

export default FirebaseForgotPassword;
